export default function capitalizeFirstLetter(string) {
  if (!string) return ''; // Handle empty string case
  return string
    .split(' ') // Split the string into words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
    .join(' '); // Join the words back into a string
}